export const CREATORS = [
  'riocurara',
  '_may_0615',
  'nopota__',
  'koharubiyori_51',
  'o2o2_o2222',
  'shiina',
  'goma_pons',
  'techi',
  'coffee_mameee',
  'akarin3331',
  'NICOLE_limacina',
  '_SHIROMISAKANA_',
  'mocchi00561',
  'sqtmr',
  'c_asaaai',
  'aaa__x_x__',
  'yokoi_0w0',
  'ibless0316',
  'noonereno',
  'pyon9956',
] as const

export type CREATOR = (typeof CREATORS)[number]

export const creatorMapTargetId: Record<CREATOR, string> = {
  riocurara: 'apex1',
  nopota__: 'apex2',
  koharubiyori_51: 'apex3',
  o2o2_o2222: 'apex4',
  shiina: 'apex5',
  goma_pons: 'apex7',
  techi: 'apex8',
  _may_0615: 'apex9',
  coffee_mameee: 'apex10',
  akarin3331: 'apex11',
  NICOLE_limacina: 'apex12',
  _SHIROMISAKANA_: 'apex13',
  mocchi00561: 'apex14',
  sqtmr: 'apex15',
  c_asaaai: 'apex16',
  aaa__x_x__: 'apex17',
  yokoi_0w0: 'apex18',
  ibless0316: 'apex19',
  noonereno: 'apex20',
  pyon9956: 'apex21',
}

export const mapApexCreatorInfo: Record<
  CREATOR,
  {
    profileCardImageURL: string
  }
> = {
  riocurara: {
    profileCardImageURL: `/static/images/profiles/${creatorMapTargetId['riocurara']}/0-min.jpg`,
  },
  nopota__: {
    profileCardImageURL: `/static/images/profiles/${creatorMapTargetId['nopota__']}/0-min.png`,
  },
  koharubiyori_51: {
    profileCardImageURL: `/static/images/profiles/${creatorMapTargetId['koharubiyori_51']}/0.jpeg`,
  },
  o2o2_o2222: {
    profileCardImageURL: `/static/images/profiles/${creatorMapTargetId['o2o2_o2222']}/0-min.jpg`,
  },
  shiina: {
    profileCardImageURL: `/static/images/profiles/${creatorMapTargetId['shiina']}/0.jpg`,
  },
  goma_pons: {
    profileCardImageURL: `/static/images/profiles/${creatorMapTargetId['goma_pons']}/0-min.jpeg`,
  },
  techi: {
    profileCardImageURL: `/static/images/profiles/${creatorMapTargetId['techi']}/0.jpg`,
  },
  _may_0615: {
    profileCardImageURL: `/static/images/profiles/${creatorMapTargetId['_may_0615']}/0-min.jpeg`,
  },
  coffee_mameee: {
    profileCardImageURL: `/static/images/profiles/${creatorMapTargetId['coffee_mameee']}/0.jpeg`,
  },
  akarin3331: {
    profileCardImageURL: `/static/images/profiles/${creatorMapTargetId['akarin3331']}/0.jpeg`,
  },
  NICOLE_limacina: {
    profileCardImageURL: `/static/images/profiles/${creatorMapTargetId['NICOLE_limacina']}/0-min.jpeg`,
  },
  _SHIROMISAKANA_: {
    profileCardImageURL: `/static/images/profiles/${creatorMapTargetId['_SHIROMISAKANA_']}/0-min.jpeg`,
  },
  mocchi00561: {
    profileCardImageURL: `/static/images/profiles/${creatorMapTargetId['mocchi00561']}/0-min.jpeg`,
  },
  sqtmr: {
    profileCardImageURL: `/static/images/profiles/${creatorMapTargetId['sqtmr']}/0.jpeg`,
  },
  c_asaaai: {
    profileCardImageURL: `/static/images/profiles/${creatorMapTargetId['c_asaaai']}/0.jpeg`,
  },
  aaa__x_x__: {
    profileCardImageURL: `/static/images/profiles/${creatorMapTargetId['aaa__x_x__']}/0-min.jpeg`,
  },
  yokoi_0w0: {
    profileCardImageURL: `/static/images/profiles/${creatorMapTargetId['yokoi_0w0']}/0.jpeg`,
  },
  ibless0316: {
    profileCardImageURL: `/static/images/profiles/${creatorMapTargetId['ibless0316']}/0-min.jpeg`,
  },
  noonereno: {
    profileCardImageURL: `/static/images/profiles/${creatorMapTargetId['noonereno']}/0.jpeg`,
  },
  pyon9956: {
    profileCardImageURL: `/static/images/profiles/${creatorMapTargetId['pyon9956']}/0-min.png`,
  },
}
